module.exports = __webpack_public_path__ + "static/media/packaging-icon.11f3ba20.jpg";